import React from "react";
import { Menu, MenuItem } from '@szhsin/react-menu';

import { faEllipsisV, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import "./custom.css";


export default function DropDownComponent(props) {

    return (
        <Menu
            align="end"
            arrow={true}
            className="dropdown"
            menuButton={
                <FontAwesomeIcon 
                    icon={ faEllipsisV } 
                    className='text-primary'
                    style={{
                        color: '#078E04',
                        cursor: 'pointer',
                        fontSize: '20px'
                    }}
                />
            }
            position="anchor"
            viewScroll="close"
        >
            {props.content.map((item) => {

                
                if (typeof item.onClick != 'undefined'){
                    
                    return (
                    
                        <MenuItem
                            href={void (0)}
                            onClick={() =>item.onClick(item.parametro)}
                        >
                            {item.titulo}
                            {/* <FontAwesomeIcon 
                                icon={ faChevronRight } 
                                className='text-primary text-end'
                                style={{
                                    color: '#078E04',
                                    cursor: 'pointer',
                                    fontSize: '15px'
                                }}
                            /> */}
                        </MenuItem>
    
                    )
                }else{
                    
                    return (
                    
                        <MenuItem
                            href={void (0)}
                            onClick={function () { props.function(item.parametro) }}
                        >
                            {item.titulo}
                            {/* <FontAwesomeIcon 
                                icon={ faChevronRight } 
                                className='text-primary text-end'
                                style={{
                                    color: '#078E04',
                                    cursor: 'pointer',
                                    fontSize: '15px',
                                    float: 'left'
                                }}
                            /> */}
                        </MenuItem>
    
                    )
                    
                }
                

            })}
        </Menu>
    )

}